document.addEventListener('DOMContentLoaded', function(event) {
  //the event occurred

gsap.registerPlugin(CSSPlugin);

  var highlightCards = document.querySelectorAll('.highlight-card');
  var pulseButtons = document.querySelectorAll('.bullet-button');
  var wrapperElement = document.querySelector('.section-marvel #Image image');

  
  pulseButtons.forEach(function(item) {
    var tlPulse = new gsap.timeline({repeat:-1, yoyo: true});
    tlPulse.set(item, {transformOrigin:"50% 50%"});
    tlPulse.to(item, {duration: 1, scale: 0.7, ease: "power1.inOut"});
    if(window.matchMedia("(pointer: coarse)").matches) {
        // touchscreen
      item.addEventListener("click", (event) => {
        var elementActive = parseInt(item.getAttribute('data-trigger-card'));
        handleBullet(elementActive);
      });
    } else {
      item.addEventListener("mouseover", (event) => {
        console.log("in");
        closeAll(event);
        var elementActive = parseInt(item.getAttribute('data-trigger-card'));
        handleBullet(elementActive);
      });
      
    }
  });

  highlightCards.forEach(function(item) {
    gsap.set(item, {autoAlpha: 0, y: -32});
  });

  wrapperElement.addEventListener('click', closeAllOutside);
  function closeAllOutside(event) {
    event.preventDefault();
    if (event.target == this) {
      closeAll(event);
    }
  }

  function closeAll(event) {
    highlightCards.forEach(function(item) {
      gsap.to(item, {autoAlpha: 0, y: -32});
      item.classList.remove('active');
    });
  }

  function handleBullet(active) {
    var bulletItemActive = document.querySelector(`.bullet-button[data-trigger-card="${active}"]`);
    
    highlightCards.forEach(function(item, index) {
      
      if (active == (index + 1)) {
        
        if ( item.classList.contains('active') ) {
          item.classList.remove('active');
          gsap.to(item, {autoAlpha: 0, y: -32});
        } else {
          item.classList.add('active');


          if(item.dataset.video != "0") {
              if(!item.classList.contains('video-mounted')) {
                item.classList.add('video-mounted');
                var newVideo = document.createElement('video');
                var insertVideo = item.querySelector('.highlight-video');
                newVideo.setAttribute('src', item.dataset.video);
                newVideo.setAttribute('playsinline', 'playsinline');
                newVideo.setAttribute('autoplay', 'autoplay');
                newVideo.setAttribute('loop', 'loop');
                newVideo.setAttribute('muted', 'muted');
                insertVideo.appendChild(newVideo);
                newVideo.currentTime = 0;
                newVideo.play();
            } else {
    
            }

          }

          
          //console.log(item.dataset.video);
          gsap.to(item, {autoAlpha: 1, y: 0});
        }
        
      } else  {
        item.classList.remove('active');
        gsap.to(item, {autoAlpha: 0, y: -32});
      }
    });
  }


  var windowWidth = window.innerWidth;
  var innerBullets = document.querySelectorAll('.stBulletInner');
  var outterBullets = document.querySelectorAll('.stBulletOutter');

  function setBulletSize() {
      var bulletRadio = {
        outter : 20,
        inner: 8
      }
      if (windowWidth < 815) {
        if (windowWidth < 600) {
            bulletRadio = {
              outter : 50,
              inner: 25
            }
        } else {
          bulletRadio = {
            outter : 40,
            inner: 16
          }
        }
    }

    innerBullets.forEach(function(item) {
      item.setAttribute("r", bulletRadio.inner);
    });
    outterBullets.forEach(function(item) {
      item.setAttribute("r", bulletRadio.outter);
    });
  }
setBulletSize();

window.addEventListener('resize', setBulletSize);


})